// Use import.meta.env (Vite) in browser builds where process is undefined; fallback to process.env for Node/SSR
const env =
  typeof import.meta !== "undefined" && import.meta.env
    ? import.meta.env
    : typeof process !== "undefined" && process.env
      ? process.env
      : {};

export const serverConfig = {
  LOGIN_URL: env.REACT_APP_LOGIN_URL || "",
  OUTE_SERVER: env.REACT_APP_OUTE_SERVER || "",
  STUDIO_SERVER: env.REACT_APP_STUDIO_SERVER || "",
  UATU_SERVER: env.REACT_APP_UATU_SERVER || "",
  FILE_UPLOAD_SERVER: env.REACT_APP_FILE_UPLOAD_SERVER || "",
  SHEET_SERVER: env.REACT_APP_SHEET_SERVER || "",
  TINY_AI_SERVER: env.REACT_APP_AI_SERVER || "",
  WC_URL: env.REACT_APP_WC_URL || "",
  FORMFLOW_URL: env.REACT_APP_FORMFLOW_URL || "",
  SHEET_URL: env.REACT_APP_SHEET_URL || "",
  EMAIL_TEMPLATE_URL: env.REACT_APP_EMAIL_TEMPLATE_URL || "",
  BLOG_URL: env.REACT_APP_BLOG_URL || "",
  AGENT_WORKFLOW_URL: env.REACT_APP_AGENT_WORKFLOW_URL || "",
  HELP_URL: env.REACT_APP_HELP_URL || "",
  WHATS_NEW_URL: env.REACT_APP_WHATS_NEW_URL || "",
  RESOURCES_URL: env.REACT_APP_RESOURCES_URL || "",
  OAUTH2_REDIRECT_URI: env.REACT_APP_OAUTH2_REDIRECT_URI || "",
  SOCKET_URL: env.REACT_APP_SOCKET_URL || "",
  MARKETPLACE_SERVER: env.REACT_APP_MARKETPLACE_SERVER || "",
  EMAIL_MARKETPLACE_SERVER: env.REACT_APP_EMAIL_MARKETPLACE_SERVER || "",
  EMAIL_MARKETPLACE_URL: env.REACT_APP_EMAIL_MARKETPLACE_URL || "",
  EMAIL_TEMPLATE_SERVER: env.REACT_APP_EMAIL_TEMPLATE_SERVER || "",
  INVOKE_API_SERVER: env.REACT_APP_INVOKE_API_SERVER || "",
  WC_LANDING_URL: env.REACT_APP_WC_LANDING_URL || "",
  TINYCOMMAND_URL: env.REACT_APP_TINYCOMMAND_URL || "",
  CMS_URL: env.REACT_APP_CMS_URL || "",
  FORM_URL: env.REACT_APP_FORM_URL || "",
  AGENT_URL: env.REACT_APP_AGENT_URL || "",
  WC_SERVER: env.REACT_APP_WC_SERVER || "",
  WORKFLOW_URL: env.REACT_APP_WORKFLOW_URL || "",
  OUTE_URL: env.REACT_APP_OUTE_URL || "",
  HUB_ORIGIN: env.REACT_APP_HUB_ORIGIN || "",
};

export function base64Encode(str: string) {
  try {
    return btoa(encodeURIComponent(str));
  } catch {
    return str;
  }
}

export function base64Decode(str: string) {
  try {
    return decodeURIComponent(atob(str));
  } catch {
    return str;
  }
}

export function base64EncodeForExternalApp(obj: any) {
  try {
    // External apps (forms, sheets, workflows, etc.) expect: atob(q) -> JSON
    return btoa(JSON.stringify(obj));
  } catch {
    // Fallback keeps internal encoding semantics if direct btoa fails
    return base64Encode(JSON.stringify(obj));
  }
}

export const dateUtils = {
  format: (date: any, fmt?: string) => {
    if (!date) return "";
    try {
      return new Date(date).toLocaleDateString();
    } catch {
      return String(date);
    }
  },
  fromNow: (date: any) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString();
  },
  convertTimestampToAgo: (timestamp: any) => {
    if (!timestamp) return "";
    try {
      const date = new Date(timestamp);
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);
      
      if (diffMins < 1) return "just now";
      if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? "s" : ""} ago`;
      if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
      if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
      return date.toLocaleDateString();
    } catch {
      return String(timestamp);
    }
  },
};

export const cookieUtils = {
  get: (name: string) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  },
  set: (name: string, value: string, options: any = {}) => {
    let cookieStr = `${name}=${encodeURIComponent(value)}; path=${options.path || "/"}`;
    if (options.expires) cookieStr += `; expires=${options.expires}`;
    document.cookie = cookieStr;
  },
  remove: (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  },
};

export default serverConfig;
